import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e23f9d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "general" }
const _hoisted_4 = {
  key: 0,
  class: "modalMunicipios"
}
const _hoisted_5 = { class: "contenedorMunicipios" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, " Seleccione el Municipio ", -1))
const _hoisted_7 = { class: "contenidoMunicipios" }
const _hoisted_8 = { class: "contenidoMunicipios" }
const _hoisted_9 = { id: "municipios" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "MUNICIPIO"),
  /*#__PURE__*/_createElementVNode("th", null, "PROVINCIA"),
  /*#__PURE__*/_createElementVNode("th", null, "REGION")
], -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { style: {"margin-top":"35px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "grid" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "rnc"
}, "RNC", -1))
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "descripcion"
}, "DESCRIPCION", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombreComercial"
}, "NOMBRE COMERCIAL", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombreRazonSocial"
}, "RAZON SOCIAL", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "gcorp"
}, "GRUPO CORPORATIVO", -1))
const _hoisted_22 = ["value"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Guardar ")
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Eliminar ")
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Navbar),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.cargando)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                  class: "img",
                  src: 
              'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
            
                }, null, 8, _hoisted_2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        (_ctx.showModalMunicipios)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("label", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalMunicipioMethod())),
                  for: "btn-modal"
                }, "X"),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "search",
                        type: "search",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                        class: "form-control",
                        placeholder: "Introduzca el nombre del municipio",
                        onKeypress: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buscar()))
                      }, null, 544), [
                        [_vModelText, _ctx.search]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("table", _hoisted_9, [
                        _hoisted_10,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.municipiosFiltrados, (municipio, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            onClick: ($event: any) => (_ctx.setMunicipio(municipio))
                          }, [
                            _createElementVNode("td", null, _toDisplayString(municipio.municipio), 1),
                            _createElementVNode("td", null, _toDisplayString(municipio.provincia), 1),
                            _createElementVNode("td", null, _toDisplayString(municipio.region), 1)
                          ], 8, _hoisted_11))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", null, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("h6", _hoisted_12, _toDisplayString(_ctx.encabezado), 1),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", null, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("input", {
                    disabled: this.empleador.disabledRnc,
                    id: "rnc",
                    type: "String",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.empleador.rnc) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 8, _hoisted_17), [
                    [_vModelText, _ctx.empleador.rnc]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("input", {
                    id: "descripcion",
                    type: "String",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.empleador.descripcion) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleador.descripcion]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("input", {
                    id: "nombreComercial",
                    type: "String",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.empleador.nombreComercial) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleador.nombreComercial]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("input", {
                    id: "nombreRazonSocial",
                    type: "String",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.empleador.nombreRazonSocial) = $event)),
                    class: "form-control form-control-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.empleador.nombreRazonSocial]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("select", {
                    id: "gcorp",
                    type: "String",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.empleador.gcorp) = $event)),
                    class: "form-select form-select-sm"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.gcorporativos, (gcorporativo, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: gcorporativo.id_gcorporativo
                      }, _toDisplayString(gcorporativo.descripcion), 9, _hoisted_22))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.empleador.gcorp]
                  ])
                ])
              ])
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.createEmpleador()), ["prevent"])),
              disabled: 
                !_ctx.empleador.rnc ||
                  !_ctx.empleador.descripcion ||
                  !_ctx.empleador.nombreRazonSocial
              
            }, _hoisted_26, 8, _hoisted_23),
            (_ctx.showDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-danger",
                  onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
                }, _hoisted_29))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.cargando]
      ])
    ])
  ]))
}